
import dayjs from 'dayjs' // 时间转换
import Adddialog from '@/components/service/Adddialog.vue'
import Identityoptions from '@/components/service/newjoin/Identityoptions.vue'
import Searchtrader from '@/components/service/newjoin/Searchtrader.vue'
import Addtrader from '@/components/service/newjoin/Addtrader.vue'
import Jointrader from '@/components/service/newjoin/Jointrader.vue'
import Contactus from '@/components/service/newjoin/Contactus.vue'
import Hostvalidate from '@/components/service/newjoin/Hostvalidate.vue'
import Toexamine from '@/components/service/newjoin/Toexamine.vue'
import Hostexamine from '@/components/service/newjoin/Hostexamine.vue'
import Emailtab from '@/components/service/newjoin/Emailtab.vue'
import Licensed from '@/components/service/newjoin/Licensed.vue'
import Emailverification from '@/components/service/newjoin/Emailverification.vue'
import Websitepost from '@/components/service/newjoin/Websitepost.vue'
import Emailverify from '@/components/service/newjoin/Emailverify.vue'
import Newtoexamine from '@/components/service/newjoin/Newtoexamine.vue'
import Servicetype from '@/components/service/newjoin/Servicetype.vue'
import Createservice from '@/components/service/newjoin/Createservice.vue'
import Joinkol from '@/components/service/newjoin/Joinkol.vue'
import Newoptions from '@/components/service/newjoin/Newoptions.vue'
export default {
  components: {
    Newoptions,
    Joinkol,
    Servicetype,
    Createservice,
    Newtoexamine,
    Emailverify,
    Websitepost,
    Emailverification,
    Licensed,
    Hostexamine,
    Toexamine,
    Adddialog,
    Identityoptions,
    Searchtrader,
    Addtrader,
    Jointrader,
    Contactus,
    Hostvalidate,
    Emailtab
  },
  data() {
    return {
      servicetypedata: [], // 服务类型数据
      servicetypedataall: [], // 服务类型数据原始数据
      subservicetypedata: [], // 次要服务类型选中数据
      servicetypeparam: {}, // 主要服务类型
      createparam: {}, // 创建服务参数
      createbool: true,
      awaitp1: '',
      awaitp2: '',
      successp: '',
      errorp1: '',
      errorp2: '',
      steptype: 0, // 认证类型---- kol-8
      successtext: this.$v('查看企业'),
      errortext: this.$v('重新提交'),
      awaitext: this.$v('好的'),
      Toexaminestate: 'await', // 数据状态
      modalshow: false, // 遮罩
      upgradeData: [], // 各种身份列表
      dialogData: {}, // 状态所有相关基础数据
      identityData: [
        {
          // 身份弹框数据
          index: 0,
          title: this.$v('我是交易商'),
          content: this.$v('品牌推广、内容获客，挖掘更多商机'),
          image: 'https://resources1.interface003.com/web20/img/service/427322197.svg',
          icon: 'https://resources1.interface003.com/web20/img/service/427320778.svg'
        },
        {
          index: 1,
          title: this.$v('我是服务商'),
          content: this.$v('提供各种外汇相关服务的机构或公司'),
          image: 'https://resources1.interface003.com/web20/img/service/427322198.svg',
          icon: 'https://resources1.interface003.com/web20/img/service/427320788.svg'
        }
      ],
      tabupgradeData: [],
      tabserviceData: [
        {
          // 切换服务商操作类型数据
          index: 2,
          title: this.$v('认领交易商'),
          content: this.$v('可管理该交易商，并可发表带有企业标识的官方内容'),
          image: 'https://resources1.interface003.com/web20/img/service/2222.png'
        },
        {
          index: 1,
          title: this.$v('我是企业员工'),
          content: this.$v('验证通过后，即可发表带有企业标识的内容'),
          image: 'https://resources1.interface003.com/web20/img/service/1111.png'
        }
      ],
      identitycollection: {}, // kol或者投资者弹框信息
      enterpriseType: 2, // 2交易商1服务商
      addtradertype: 1, // 1加入还是2认领3认证
      traderdata: {}, // 选择加入或者认领的交易商服务商的信息
      isExistAdmin: true, // 是否验证通过
      jointraderoaram: {}, // 管理员审核加入表单参数
      contactpost: {}, // 联系我们-其他参数
      websitearr: [], // 官方网址
      weburl: '', // 选择的官方网址-官网验证设置地址
      wikinum: '', // 天眼号
      enterpriseCode: '', // 企业code
      Licensedarr: [], // 持牌机构邮箱列表
      email: '', // 选中的邮箱
      emailCode: '', // 邮箱code
      hzemail: '', // 邮箱后缀
      prefixesarr: [], // 邮箱前缀
      emailnexttimer: null,
      goodregulatory: false, // 监管评分是否大于5为true小于5为false
      apptype: 6, // 默认是6，用户申请加入，持牌机构加入调这个接口的时候根据场景传2或者4
      homeshow: 0, // 哪些页面直接被进入--- 1-加入认领； 2----加入
      pdi: '',
      emaiarr: [],
      searchshow: false,
      verifyshow: false,
      kolshow: false,
      kolpidata: {},
      istab: true,
      emailAuditType: 3 // 邮箱发送类型--老版本流程 Default = 0小于等于5分，或服务商 Let5 = 1交易商5分以上，或服务商 Gt5 = 2持牌机构 Linese = 3
    }
  },
  computed: {
    contactusp() {
      // 联系我们按钮动态
      if (this.contactpost.userName && this.contactpost.name && this.contactpost.email) return false
      return true
    },
    title() {
      if (this.enterpriseType == 2 && this.addtradertype == 2) {
        return '认领交易商'
      } else if (this.enterpriseType == 2 && this.addtradertype == 1) {
        return '加入交易商'
      } else if (this.enterpriseType == 1 && this.addtradertype == 2) {
        return '认领服务商'
      } else if (this.enterpriseType == 1 && this.addtradertype == 1) {
        return '加入服务商'
      } else {
        return '服务商认证'
      }
    },
    upgradelang() {
      // 判断是否为长语言
      const lang = ['zh-cn', 'zh']
      if (lang.includes(this.$store.state.LanguageCode)) {
        return true
      } else {
        return false
      }
    }
  },
  watch: {
    createparam: {
      // 创建服务商提交审核按钮状态
      handler(newValue, oldValue) {
        const bool =
          this.createparam.companyName &&
          this.createparam.companyShortName &&
          this.createparam.companyWebSite &&
          this.createparam.companyFoundDate &&
          this.createparam.name &&
          this.createparam.companySize &&
          this.createparam.contactInfo
        console.log(bool, 22213)
        this.createbool = bool
      },
      deep: true
    }
  },
  mounted() {
    console.log(123)
    // this.$refs.tabkolpi.open()
  },
  methods: {
    open(result) {
      // 加入认领创建流程
      if (!this.$store.state.contentcookie) {
        // 未登录
        return this.$store.commit('loginClose', true)
      }
      this.dialogData = {}
      for (const key in result) {
        this.$set(this.dialogData, key, result[key])
      }
      this.dialogData.resultPageType = this.dialogData.approvalStatus || this.dialogData.resultPageType
      this.apptype = 6
      console.log(JSON.stringify(this.dialogData), 9999, this.$store)
      if (!this.dialogData.pdi) {
        // 没有任何操作记录是弹出初始化弹框
        this.openupgrade()
      } else {
        if ((this.dialogData.applicationContentType == 13 || this.dialogData.applicationContentType == 8) && this.dialogData.resultPageType == 3) {
          this.openupgrade()
          return
        }
        this.pdi = this.dialogData.pdi
        this.personalapplicationdetailfn((res) => {
          // 获取稍后提交参数
          this.simplemain(res.enterpriseCode, async (r) => {
            // 根据code获取服务商或交易商信息
            this.enterpriseType = res.enterpriseType
            this.enterpriseCode = res.enterpriseCode
            this.traderdata = {}
            for (const key in r) {
              this.$set(this.traderdata, key, r[key])
            }
            // this.wikinum = this.$store.state.wikinum
            await this.getuserisenterprise()
            if (res.applicationType == 2) {
              // 认领
              this.addtradertype = 2
            } else if (res.applicationType == 4) {
              // 认证
              this.addtradertype = 3
            } else if (res.applicationType == 6) {
              // 加入
              this.addtradertype = 1
            }
            if (this.dialogData.applicationContentType == 2) {
              // 指定域名验证 指定域名认证
              this.weburl = res.applicationContent.domain
            }
            console.log(r, 5555)
            this.reviewstatusfn(this.dialogData)
          }).catch((err) => {
            console.log(err, 887)
          })
          // this.userhomemessagebarfn(this.dialogData)
        })
      }
    },
    openkol(result) {
      // 申请领取kol
      if (!this.$store.state.contentcookie) {
        // 未登录
        return this.$store.commit('loginClose', true)
      }
      this.identitycollection = {}
      for (const key in result) {
        this.$set(this.dialogData, key, result[key])
      }
      if (this.dialogData.content == 1) {
        this.$set(this.identitycollection, 'type', 1)
        this.$nextTick(() => {
          this.$refs.Joinkol.open()
        })
      } else if (this.dialogData.content == 3) {
        this.$set(this.identitycollection, 'type', 3)
        this.$nextTick(() => {
          this.$refs.Joinkol.open()
        })
      }
    },
    openauthentication(result) {
      // 服务商认证，一般就是管理员员工认证
      if (!this.$store.state.contentcookie) {
        // 未登录
        return this.$store.commit('loginClose', true)
      }
      this.dialogData = {}
      for (const key in result) {
        this.$set(this.dialogData, key, result[key])
      }
      this.addtradertype = 3
      this.enterpriseType = 1
      this.apptype = 6
      console.log(this.dialogData, 31133)
      this.enterpriseCode = this.dialogData.enterpriseCode
      if (this.dialogData.tagType == 1) {
        // 未认证
        this.simplemain(this.dialogData.enterpriseCode, (res) => {
          console.log(res, 333)
          for (const key in res) {
            this.$set(this.traderdata, key, res[key])
          }
          this.$nextTick(() => {
            this.$refs.jointrader.open()
          })
        })
      } else {
        this.reviewstatusfn(this.dialogData)
      }
    },
    openupgrade() {
      // 打开身份升级
      // this.$api.common.CV3({
      //   userId: this.$store.state.user.userId || ''
      // }, {
      //   Routes: 'wikifx$getauthenticationrolev4'
      // }).then((res) => {
      //   console.log(res.wikifx.getauthenticationrolev4.data, 222)
      //   const data = (res && res.wikifx && res.wikifx.getauthenticationrolev4 && res.wikifx.getauthenticationrolev4.data && res.wikifx.getauthenticationrolev4.data.items) || []
      //   data.forEach((item) => { // 之所以这么改因为产品设计图把app和web设计的不统一
      //     if (item.type == 1) {
      //       item.image = 'https://resources1.interface003.com/web20/img/service/tzz1.svg?v=22'
      //     } else if (item.type == 3) {
      //       item.image = 'https://resources1.interface003.com/web20/img/service/kol1.svg?v=22'
      //     } else if (item.type == 2) {
      //       item.image = 'https://resources1.interface003.com/web20/img/service/upgrade-2.svg?v=22'
      //     }
      //   })
      //   this.upgradeData = [...data]
      //   this.$nextTick(() => {
      //     if (data?.length == 1) {
      //       this.upgrade(data[0])
      //       return
      //     }
      //     this.$refs.upgrade.open()
      //   })
      // })
      this.$api.common
        .CV3(
          {
            userId: this.$store.state.user.userId || ''
          },
          {
            Routes: 'wikifx$usercentervalidatekol'
          }
        )
        .then((res) => {
          console.log(res, 222)
          const data = res?.wikifx?.usercentervalidatekol?.data
          console.log(data, 889)
          if (data) {
            // kol
            this.upgradeData = [
              {
                type: 1,
                bgimg: 'https://resources1.interface003.com/web20/img/service/bg/pi.png?v=1',
                bg: 'https://resources1.interface003.com/web20/img/service/bg/pibg.png?v=1',
                shadow: '0px 9px 10px 0px #A4C6D24D',
                textimg: 'https://resources1.interface003.com/web20/img/service/bg/piicon.png',
                title: this.$v('我是投资者'),
                content: this.$v('参与外汇市场交易实现资产增值')
              },
              {
                type: 4,
                bgimg: 'https://resources1.interface003.com/web20/img/service/bg/dealer.png?v=1',
                bg: 'https://resources1.interface003.com/web20/img/service/bg/dealerbg.png?v=1',
                shadow: '0px 9px 10px 0px #7CBCF629',
                icon: 'https://resources1.interface003.com/web20/img/service/bg/dealer.svg',
                title: this.$v('我是交易商'),
                content: this.$v('为投资者提供外汇市场交易服务商业机构')
              },
              {
                type: 5,
                bgimg: 'https://resources1.interface003.com/web20/img/service/bg/service.png?v=1',
                bg: 'https://resources1.interface003.com/web20/img/service/bg/servicebg.png?v=1',
                shadow: '0px 4px 10px 0px #F9CD544D',
                icon: 'https://resources1.interface003.com/web20/img/service/bg/serviceicon.png?v=2',
                title: this.$v('我是服务商'),
                content: this.$v('提供各种外汇相关服务的机构或公司')
              }
            ]
          } else {
            // 投资者
            this.upgradeData = [
              {
                type: 3,
                bgimg: 'https://resources1.interface003.com/web20/img/service/bg/kol.png?v=1',
                bg: 'https://resources1.interface003.com/web20/img/service/bg/kolbg.png?v=1',
                shadow: '0px 9px 10.6px 0px #DF977640',
                textimg: 'https://resources1.interface003.com/web20/img/service/bg/kolicon.png',
                title: this.$v('我是KOL'),
                text: '我是{0}',
                content: this.$v('行业具有影响力的意见领袖')
              },
              {
                type: 4,
                bgimg: 'https://resources1.interface003.com/web20/img/service/bg/dealer.png?v=1',
                bg: 'https://resources1.interface003.com/web20/img/service/bg/dealerbg.png?v=1',
                shadow: '0px 9px 10px 0px #7CBCF629',
                icon: 'https://resources1.interface003.com/web20/img/service/bg/dealer.svg',
                title: this.$v('我是交易商'),
                content: this.$v('为投资者提供外汇市场交易服务商业机构')
              },
              {
                type: 5,
                bgimg: 'https://resources1.interface003.com/web20/img/service/bg/service.png?v=1',
                bg: 'https://resources1.interface003.com/web20/img/service/bg/servicebg.png?v=1',
                shadow: '0px 4px 10px 0px #F9CD544D',
                icon: 'https://resources1.interface003.com/web20/img/service/bg/serviceicon.png?v=2',
                title: this.$v('我是服务商'),
                content: this.$v('提供各种外汇相关服务的机构或公司')
              }
            ]
          }
          this.$nextTick(() => {
            this.$refs.upgrade.open()
          })
        })
    },
    gettabupgradefn() {
      // 切换身份打开身份shen升级
      this.$api.common
        .CV3(
          {
            userId: this.$store.state.user.userId || ''
          },
          {
            Routes: 'wikifx$usercentervalidatekol'
          }
        )
        .then((res) => {
          console.log(res, 222)
          const data = res?.wikifx?.usercentervalidatekol?.data
          console.log(data, 889)
          if (data) {
            // kol
            this.tabupgradeData = [
              {
                type: 4,
                bgimg: 'https://resources1.interface003.com/web20/img/service/bg/dealer.png?v=1',
                bg: 'https://resources1.interface003.com/web20/img/service/bg/dealerbg.png?v=1',
                icon: 'https://resources1.interface003.com/web20/img/service/bg/dealer.svg',
                title: this.$v('我是交易商'),
                shadow: '0px 9px 10px 0px #7CBCF629',
                content: this.$v('为投资者提供外汇市场交易服务商业机构')
              },
              {
                type: 5,
                bgimg: 'https://resources1.interface003.com/web20/img/service/bg/service.png?v=1',
                bg: 'https://resources1.interface003.com/web20/img/service/bg/servicebg.png?v=1',
                shadow: '0px 4px 10px 0px #F9CD544D',
                icon: 'https://resources1.interface003.com/web20/img/service/bg/serviceicon.png?v=2',
                title: this.$v('我是服务商'),
                content: this.$v('提供各种外汇相关服务的机构或公司')
              },
              {
                type: 1,
                bgimg: 'https://resources1.interface003.com/web20/img/service/bg/pi.png?v=1',
                bg: 'https://resources1.interface003.com/web20/img/service/bg/pibg.png?v=1',
                textimg: 'https://resources1.interface003.com/web20/img/service/bg/piicon.png',
                title: this.$v('我是投资者'),
                content: this.$v('参与外汇市场交易实现资产增值')
              }
            ]
          } else {
            // 投资者
            this.tabupgradeData = [
              {
                type: 4,
                bgimg: 'https://resources1.interface003.com/web20/img/service/bg/dealer.png?v=1',
                bg: 'https://resources1.interface003.com/web20/img/service/bg/dealerbg.png?v=1',
                shadow: '0px 9px 10px 0px #7CBCF629',
                icon: 'https://resources1.interface003.com/web20/img/service/bg/dealer.svg',
                title: this.$v('我是交易商'),
                content: this.$v('为投资者提供外汇市场交易服务商业机构')
              },
              {
                type: 5,
                bgimg: 'https://resources1.interface003.com/web20/img/service/bg/service.png?v=1',
                bg: 'https://resources1.interface003.com/web20/img/service/bg/servicebg.png?v=1',
                shadow: '0px 4px 10px 0px #F9CD544D',
                icon: 'https://resources1.interface003.com/web20/img/service/bg/serviceicon.png?v=2',
                title: this.$v('我是服务商'),
                content: this.$v('提供各种外汇相关服务的机构或公司')
              },
              {
                type: 3,
                bgimg: 'https://resources1.interface003.com/web20/img/service/bg/kol.png?v=1',
                bg: 'https://resources1.interface003.com/web20/img/service/bg/kolbg.png?v=1',
                shadow: '0px 9px 10.6px 0px #DF977640',
                textimg: 'https://resources1.interface003.com/web20/img/service/bg/kolicon.png',
                title: this.$v('我是KOL'),
                text: '我是{0}',
                content: this.$v('行业具有影响力的意见领袖')
              }
            ]
          }
          this.$nextTick(() => {
            this.$refs.tabupgrade.open()
          })
        })
    },
    tabupgradefn(item, bool) {
      // 切换身份
      this.istab = bool
      if (item.type == 1) {
        // 投资者 (window).Communication('backApp', JSON.stringify(true))
        // const obj = { type: JSON.stringify(item.type), text: this.$v('投资者') }
        this.$nextTick(() => {
          this.sendupgradefn({ type: item.type }, () => {
            // (window).Communication('switchIdentitySuccess', JSON.stringify(obj))
            // this.$emit('switchIdentitySuccess', obj)
            this.$set(this.kolpidata, 'type', item.type)
            this.$set(this.kolpidata, 'text', this.$v('投资者'))
            this.close()
            this.$nextTick(() => {
              this.modalshow = true
              this.$nextTick(() => {
                this.kolshow = true
              })
            })
          })
        })
      } else if (item.type == 3) {
        // kol
        console.log(222)
        // const obj = { type: JSON.stringify(item.type), text: 'KOL' }
        this.$nextTick(() => {
          this.sendupgradefn({ type: item.type }, () => {
            // (window).Communication('switchIdentitySuccess', JSON.stringify(obj))
            // this.$emit('switchIdentitySuccess', obj)
            this.$set(this.kolpidata, 'type', item.type)
            this.$set(this.kolpidata, 'text', this.$v('KOL'))
            this.close()
            this.$nextTick(() => {
              this.modalshow = true
              this.$nextTick(() => {
                this.kolshow = true
              })
            })
          })
        })
      } else if (item.type == 4) {
        // 交易商
        this.close()
        if (bool) {
          this.enterpriseType = 2
          this.$nextTick(() => {
            this.$refs.Mytrader.open()
          })
        } else {
          this.userhomemessagebarfn(() => {
            this.enterpriseType = 2
            this.$nextTick(() => {
              this.$refs.Mytrader.open()
            })
          })
        }
      } else if (item.type == 5) {
        // 服务商
        this.close()
        if (bool) {
          this.enterpriseType = 1
          this.$nextTick(() => {
            this.$refs.Mytrader.open()
          })
        } else {
          this.userhomemessagebarfn(() => {
            this.enterpriseType = 1
            this.$nextTick(() => {
              this.$refs.Mytrader.open()
            })
          })
        }
      }
    },
    userhomemessagebarfn(fn) {
      this.$api.find
        .getuserhomemessagebar(
          {
            userId: this.$store.state.user.userId || ''
          },
          {
            Routes: 'weenterpriseaudit$userhomemessagebar'
          }
        )
        .then((res) => {
          const d = res?.weenterpriseaudit?.userhomemessagebar?.data || {}
          if (d.pdi && !(d.applicationContentType == '13' && d.applicationType == '7')) {
            d.resultPageType = d.approvalStatus
            this.reviewstatusfn(d)
          } else {
            fn()
          }
        })
        .catch(() => {
          console.log('getuserhomeuserinfo')
        })
    },
    closekol() {
      if (this.kolshow) {
        this.kolshow = false
        this.modalshow = false
        this.$emit('switchIdentitySuccess', this.kolpidata)
      }
    },
    upgrade(item) {
      // 领取不同用户身份
      for (const key in item) {
        this.$set(this.identitycollection, key, item[key])
      }
      if (item.type == 1) {
        // 点击我是投资关闭弹框
        this.sendupgradefn(item)
      } else if (item.type == 3) {
        // 打开我是kol第一步
        this.sendupgradefn(item)
      } else if (item.type == 2) {
        // 我是金融从业者
        this.close()
        this.$nextTick(() => {
          this.$refs.Identity.open()
        })
      }
    },
    dealeropen(code) {
      // 交易商详情页当前企业无管理员，--- 加入认领流程
      this.enterpriseType = 2
      this.enterpriseCode = code
      this.homeshow = 1
      this.apptype = 6
      console.log(code, 112123)
      this.$refs.tabservice.open()
    },
    dealerjoin(code) {
      // 交易商详情页当前企业有管理员，--- 加入流程
      this.enterpriseType = 2
      this.enterpriseCode = code
      this.homeshow = 2
      this.apptype = 6
      console.log(code, 11212)
      this.simplemain(code, (res) => {
        this.jointrader(res)
      })
    },
    servicejoin(code) {
      // 服务商详情页当前企业有管理员，--- 加入流程
      this.enterpriseType = 1
      this.homeshow = 2
      this.apptype = 6
      this.enterpriseCode = code
      this.simplemain(code, (res) => {
        this.jointrader(res)
      })
    },
    tabservice(item) {
      // 交易商详情页加入认领流程;选择加入还是认领
      console.log(item, 9995)
      if (item == 1) {
        // 加入交易商
        this.simplemain(this.enterpriseCode, (res) => {
          this.jointrader(res)
        })
      } else if (item == 2) {
        // 认领交易商
        this.simplemain(this.enterpriseCode, (res) => {
          this.claimtrader(res, 'tabserviceid')
        })
      }
    },
    sendupgradefn(item, fn) {
      // 发送提交kol和投资者身份身份
      this.$refs.upgrade.loadfn()
      this.$api.common
        .CV3(
          {
            userId: this.$store.state.user.userId || '',
            type: item.type
          },
          {
            Routes: 'weenterpriseaudit$identitycollection'
          }
        )
        .then((res) => {
          this.$refs.upgrade.loadfn()
          console.log(res, 222)
          const result = res && res.weenterpriseaudit && res.weenterpriseaudit.identitycollection
          if (result.success) {
            if (result.data && result.data.messageModel.succeed) {
              // && result.data.messageModel.succeed
              this.close()
              this.$emit('succeedfn')
              // this.$nextTick(() => {
              //   console.log(this.$refs, 3333)
              //   this.$refs.Joinkol.open()
              // })
              fn()
            } else {
              this.$message({
                message: item.cueWord,
                type: 'info',
                duration: 2000,
                onClose: () => {}
              })
              this.close()
            }
          } else {
            this.$message({
              message: this.$v('数据获取失败,请重新尝试'),
              type: 'error'
            })
          }
        })
        .catch(() => {
          this.$refs.upgrade.loadfn()
          this.$message({
            message: this.$v('数据获取失败,请重新尝试'),
            type: 'error'
          })
        })
    },
    identity(val) {
      // 交易商身份和服务商身份选择点击下一步
      this.close()
      if (val == 0) {
        // 交易商选择
        this.enterpriseType = 2
      } else if (val == 1) {
        // 服务商选择
        this.enterpriseType = 1
      }
      this.$refs.Mytrader.open()
    },
    mytraderpre() {
      // 搜索交易商、服务商上一步
      this.close()
      this.$nextTick(() => {
        if (this.istab) {
          this.$refs.upgrade.open()
        } else {
          this.$refs.tabupgrade.open()
        }
      })
    },
    identitypre() {
      // 身份选择上一步
      this.close()
      this.$nextTick(() => {
        if (this.upgradeData?.length == 1) {
          return
        }
        this.$refs.upgrade.open()
      })
    },
    upgradeypre() {
      this.close()
    },
    jointrader(item) {
      // 加入流程
      this.addtradertype = 1
      this.enterpriseCode = item.code
      console.log(item, 8886)
      this.joinverifyfn(item.code, (res) => {
        // this.$refs.stateload.close()
        for (const key in item) {
          this.$set(this.traderdata, key, item[key])
        }
        this.$nextTick(() => {
          this.isExistAdmin = res.isExistAdmin
          if (res.isExistAdmin) {
            // 存在管理员，打开选择
            this.close()
            this.$nextTick(() => {
              this.$refs.jointrader.open()
            })
          } else {
            // 不不存在管理员，直接打开邮箱验证
            this.totraderverify({ index: 0 })
            // this.$refs.jointrader.open()
          }
        })
      })
    },
    claimtrader(item, id = '#mytrader') {
      // 认领流程
      this.addtradertype = 2
      this.joinverifyfn(item.code, (bool, text) => {
        for (const key in item) {
          this.$set(this.traderdata, key, item[key])
        }
        this.enterpriseCode = item.code
        this.$nextTick(() => {
          if (!bool) {
            // 验证通过，打开认领交易商选择弹框--样式和加入流程一致
            this.close()
            this.$refs.jointrader.open()
          } else {
            // 不确定，待定！！！！！！！！！！！
            this.$Dialog
              .confirm({
                title: this.$v('提示'),
                message: text,
                confirmButtonColor: 'rgba(50, 110, 250, 1)',
                cancelButtonColor: 'rgba(50, 110, 250, 1)',
                confirmButtonText: this.$v('认领'),
                cancelButtonText: this.$v('取消'),
                className: 'joinclass',
                overlayClass: 'overlayClass'
              })
              .then(() => {
                // on confirm
                this.close()
                this.$nextTick(() => {
                  this.$refs.jointrader.open()
                })
              })
              .catch(() => {
                // this.close()
              })
          }
        })
      })
    },
    joinverifyfn(enterpriseCode, fn) {
      // 加入或者认领接口验证接口
      // this.$refs.Mytrader.loadfn()
      this.$api.common
        .CV3(
          {
            userId: this.$store.state.user.userId || '',
            enterpriseCode, // 服务商或者交易商code
            enterpriseType: this.enterpriseType, // 服务商1，交易商2
            type: this.addtradertype // 1、加入 2、认领
          },
          {
            Routes: 'westaffmanage$joinverify'
          }
        )
        .then((res) => {
          // this.$refs.Mytrader.loadfn()
          console.log(res, 777)
          const joinv = res && res.westaffmanage && res.westaffmanage.joinverify && res.westaffmanage.joinverify.data
          if (joinv.succeed && this.addtradertype == 1) {
            fn(joinv)
          } else if (joinv.succeed && !joinv.isExistAdmin) {
            // 正常认领和加入
            fn()
          } else if (joinv.succeed && joinv.isExistAdmin) {
            // 以及管理员，认领有弹框
            if (this.addtradertype == 1) {
              this.$message.error(joinv.message)
            } else if (this.addtradertype == 2) {
              console.log(789)
              fn(true, joinv.message)
            }
          } else {
            this.$message.error(joinv.message)
          }
        })
        .catch(() => {
          // this.$refs.Mytrader.loadfn()
          this.$message.error(this.$v('接口超时，重新提交'))
        })
    },
    async totraderverify(item, code) {
      // 加入流程方式选择
      if (this.addtradertype == 1) {
        // 加入流程选择
        if (item.index == 0) {
          // 企业邮箱验证加入
          this.statistics(6, 6) // 统计
          this.goodregulatory = false
          this.websiteoremailfn(2, 2, (res) => {
            // 获取邮箱列表
            if (res.length == 0) {
              this.$message.error(this.$v('暂无数据'))
              return
            }
            this.Licensedarr = [...res] // 后缀
            this.email = ''
            this.hzemail = ''
            this.close()
            this.$nextTick(() => {
              this.$refs.Emailverification.open()
            })
          })
        } else if (item.index == 1) {
          // 管理员审核加入
          this.statistics(6, 5) // 统计
          this.jointraderoaram = {}
          this.close()
          this.$nextTick(() => {
            this.$refs.filltrader.open()
          })
        }
      } else if (this.addtradertype == 2) {
        // 认领流程选择
        if (item.index == 0) {
          // 官方域名验证认领
          this.statistics(2, 2) // 统计
          await this.getuserisenterprise()
          this.getweburlfn((val) => {
            if (val.length == 0) {
              this.$message.error(this.$v('暂无数据'))
              return
            }
            this.weburl = val[0]
            this.websitearr = [...val]
            this.close()
            this.$nextTick(() => {
              this.$refs.hostvalidate.open()
            })
          })
        } else if (item.index == 1) {
          // 邮箱验证认领
          this.statistics(2, 6) // 统计
          // this.close()
          // this.$nextTick(() => {
          //   this.$refs.Emailtab.open()
          // })
          this.websiteoremailfn(1, 2, (res) => {
            // 获取邮箱列表
            this.$nextTick(() => {
              if (res.length == 0) {
                this.emaiarr = []
                this.tabemail({ index: 1 })
                return
              }
              this.close()
              this.$nextTick(() => {
                this.$refs.Emailtab.open()
              })
            })
          })
        } else if (item.index == 2) {
          // 方式三：官网发文认领
          this.statistics(2, 3) // 统计
          await this.getuserisenterprise()
          this.close()
          this.weburl = ''
          this.$nextTick(() => {
            this.$refs.Websitepost.open()
          })
        } else if (item.index == 3) {
          // 人工客服认领
          this.statistics(2, 14) // 统计
          this.close()
          this.$nextTick(() => {
            this.$refs.contactus.open()
            this.$nextTick(() => {
              // this.traderdata
              const param = {
                userId: this.$store.state.user.userId || '', // 登录用户id
                code: this.traderdata.code, // 企业code
                // enterpriseType: this.enterpriseType, // 企业类型
                // pdi: this.dialogData.pdi,
                name: this.traderdata.localFullName || this.traderdata.showName || this.traderdata.shortName
                // applicationType: this.addtradertype == 2 ? 2 : 4
              }
              this.$refs.contactusref.setdata(param)
            })
          })
        }
      } else if (this.addtradertype == 3) {
        // 认证流程选择
        // const t = item.index == 1 ? 14 : (this.traderdata.isBelongTo ? 11 : 12)
        // this.statistics(2, t) // 统计
        if (item.index == 0) {
          // 官方域名验证认证
          // const t = item.index == 1 ? 14 : (this.traderdata.isBelongTo ? 11 : 12)
          this.statistics(4, 2) // 统计
          await this.getuserisenterprise()
          this.getweburlfn((val) => {
            if (val.length == 0) {
              this.$message.error(this.$v('暂无数据'))
              return
            }
            this.weburl = val[0]
            this.websitearr = [...val]
            this.close()
            this.$nextTick(() => {
              this.$refs.hostvalidate.open()
            })
          })
        } else if (item.index == 1) {
          // 邮箱验证认证
          this.statistics(4, 6) // 统计
          this.$refs.Emailtab.loadfn()
          this.goodregulatory = false
          this.apptype = 4
          this.websiteoremailfn(2, 2, (res) => {
            // 获取邮箱列表
            this.$refs.Emailtab.loadfn()
            if (res.length == 0) {
              this.$message.error(this.$v('暂无数据'))
              return
            }
            this.Licensedarr = [...res] // 后缀
            this.email = ''
            this.hzemail = ''
            this.emailprefixfn((rt) => {
              console.log(rt, 545)
              this.prefixesarr = rt?.prefixes || []
              this.close()
              this.$nextTick(() => {
                this.$refs.Emailverification.open()
              })
            })
          })
        } else if (item.index == 2) {
          // 方式三：官网发文认证
          this.statistics(4, 3) // 统计
          await this.getuserisenterprise()
          this.close()
          this.weburl = ''
          this.$nextTick(() => {
            this.$refs.Websitepost.open()
          })
        } else if (item.index == 3) {
          // 人工客服认证
          this.statistics(4, 14) // 统计
          this.close()
          this.$nextTick(() => {
            this.$refs.contactus.open()
            this.$nextTick(() => {
              // this.traderdata
              const param = {
                userId: this.$store.state.user.userId || '', // 登录用户id
                code: this.traderdata.code, // 企业code
                // enterpriseType: this.enterpriseType, // 企业类型
                // pdi: this.dialogData.pdi,
                name: this.traderdata.localFullName || this.traderdata.showName || this.traderdata.shortName
                // applicationType: this.addtradertype == 2 ? 2 : 4
              }
              this.$refs.contactusref.setdata(param)
            })
          })
        }
      }
    },
    tabemail(item) {
      // 邮箱认领选择
      if (item.index == 0) {
        // 持牌机构邮箱验证
        this.$nextTick(() => {
          this.apptype = 2
          this.websiteoremailfn(1, 2, (res) => {
            // 获取邮箱列表
            if (res.length == 0) {
              this.$message.error(this.$v('暂无数据'))
              return
            }
            this.close()
            this.emaiarr = [...res]
            this.Licensedarr = [...res]
            this.email = ''
            this.$nextTick(() => {
              this.$refs.Licensed.open()
            })
          })
        })
      } else if (item.index == 1) {
        // 企业邮箱验证
        this.$refs.Emailtab.loadfn()
        this.apptype = 2
        this.goodregulatoryscorefn((t) => {
          this.goodregulatory = t
          this.websiteoremailfn(2, 2, (res) => {
            // 获取邮箱列表
            this.$refs.Emailtab.loadfn()
            if (res.length == 0) {
              this.$message.error(this.$v('暂无数据'))
              return
            }
            this.Licensedarr = [...res] // 后缀
            this.email = ''
            this.hzemail = ''
            this.emailprefixfn((rt) => {
              console.log(rt, 545)
              this.prefixesarr = rt?.prefixes || []
              this.close()
              this.$nextTick(() => {
                this.$refs.Emailverification.open()
              })
            })
          })
        })
      }
    },
    setemaifn(val) {
      // 选择持牌机构邮箱
      this.email = val
    },
    sendlicensedcodefn() {
      // 发送持牌机构验证码
      this.sendcodefn(this.email, 3, (res) => {
        this.close()
        console.log(res, 665)
        this.$nextTick(() => {
          this.verifyshow = true
          this.$refs.Emailverify.open()
          this.emailAuditType = 3
          this.$nextTick(() => {
            this.$refs.Emailverifyref.counttimefn()
          })
        })
      })
    },
    emailvalidatepre() {
      // 邮箱验证码输入返回上一步
      if (this.emailAuditType == 3) {
        // 持牌机构
        this.close()
        this.$nextTick(() => {
          this.$refs.Licensed.open()
        })
      } else {
        this.close()
        this.$nextTick(() => {
          this.$refs.Emailverification.open()
        })
      }
      this.verifyshow = false
    },
    aginfn() {
      // 重新发送邮箱
      this.sendcodefn(this.email, 3, (res) => {})
    },
    sethzemail(val1, val2) {
      // 获取企业邮箱验证邮箱
      this.hzemail = val2
      this.email = `${val1}${val2}`
    },
    verifyvalfn(val) {
      // 邮箱认证
      this.emailCode = val
      this.$refs.Emailverify.loadfn()
      this.emailverifyfn((res) => {
        this.Toexaminestate = 'success'
        this.successp = this.addtradertype == 2 ? this.$v('恭喜您，认领成功') : this.addtradertype == 3 ? this.$v('恭喜您，认证成功') : this.$v('恭喜您，加入成功')
        this.successtext = this.addtradertype == 1 ? this.$v('查看企业') : this.$v('管理企业')
        setTimeout(() => {
          this.$refs.stateawait.open()
          this.$emit('succeedfn')
        }, 200)
      })
    },
    valiemailfn() {
      // 企业邮箱认证发送验证码 小于等于5分，或服务商 Let5 = 1---交易商5分以上，或服务商 Gt5 = 2
      const v = this.goodregulatory ? 2 : 1
      this.sendcodefn(this.email, v, (res) => {
        this.close()
        this.$nextTick(() => {
          this.verifyshow = true
          this.$refs.Emailverify.open()
          this.emailAuditType = v
          this.$nextTick(() => {
            this.$refs.Emailverifyref.counttimefn()
            this.emailnexttimer = setInterval(() => {
              // 轮询邮箱快速验证
              this.checkuserinenterprisefn(() => {
                this.$message({
                  message: this.$v('邮箱快捷验证成功！'),
                  type: 'warning'
                })
                this.Toexaminestate = 'success'
                this.successp = this.addtradertype == 2 ? this.$v('恭喜您，认领成功') : this.addtradertype == 3 ? this.$v('恭喜您，认证成功') : this.$v('恭喜您，加入成功')
                this.successtext = this.addtradertype == 1 ? this.$v('查看企业') : this.$v('管理企业')
                this.close()
                this.$nextTick(() => {
                  clearInterval(this.emailnexttimer)
                  console.log(this.emailnexttimer, 789)
                  this.$refs.stateawait.open()
                  this.$emit('succeedfn')
                })
              })
            }, 2500)
          })
        })
      })
    },
    checkuserinenterprisefn(fn) {
      // 校验用户是否在指定企业，如果在企业中则返回false-轮询检查如果已经被指定了直接跳转到成功页面
      this.$api.common
        .CV3(
          {
            userId: this.$store.state.user.userId || '',
            enterpriseCode: this.enterpriseCode,
            applicationType: this.apptype
          },
          {
            Routes: 'weenterpriseaudit$checkuserinenterprise'
          }
        )
        .then((res) => {
          console.log(res, 666)
          const checkuserinenterprise =
            res && res.weenterpriseaudit && res.weenterpriseaudit.checkuserinenterprise && res.weenterpriseaudit.checkuserinenterprise.data && res.weenterpriseaudit.checkuserinenterprise.data.pdi
          if (checkuserinenterprise) fn()
        })
    },
    valiweburlfn() {
      // 官方域名验证认领认证
      this.$refs?.hostvalidate.loadfn()
      this.domaincheckfn((res) => {
        console.log(res, 777)
        this.$refs.hostvalidate.loadfn()
        this.close()
        for (const key in res) {
          this.$set(this.dialogData, key, res[key])
        }
        this.$nextTick(() => {
          this.$refs.stateload.open()
          this.pdi = res.pdi
          this.resultpagetimer(res.pdi, (d, bool = true) => {
            console.log(d, 7376)
            if (bool) {
              this.reviewstatusfn(d)
            } else {
              this.$refs?.hostvalidate.open()
            }
          })
        })
      })
    },
    checkurlfn() {
      // 点击官方域名验证文件
      this.$refs?.hostvalidate.loadfn()
      this.$api.common
        .CV3(
          {
            url: `${this.weburl}/${this.wikinum}.txt`
          },
          {
            Routes: 'weenterpriseaudit$checkurl'
          }
        )
        .then((res) => {
          console.log(res, 556)
          this.$refs.hostvalidate.loadfn()
          const result = res && res.weenterpriseaudit && res.weenterpriseaudit.checkurl && res.weenterpriseaudit.checkurl.data
          if (result) {
            this.$message({
              message: this.$v('验证成功'),
              type: 'success'
            })
          } else {
            this.$message({
              message: this.$v('验证失败'),
              type: 'error'
            })
          }
        })
        .catch(() => {
          this.$refs?.hostvalidate.loadfn()
          this.$message({
            message: this.$v('验证失败'),
            type: 'error'
          })
        })
    },
    hostaginfn() {
      // 官网域名验证重新提交
      this.valiweburlfn()
    },
    closeawaitfn() {
      // 取消官网域名认领
      this.listcancelf((ret) => {
        // this.enterpriseCode = ret.enterpriseCode
        this.simplemain(this.enterpriseCode, (res) => {
          console.log(JSON.stringify(res), 333, res.website)
          for (const key in res) {
            this.$set(this.traderdata, key, res[key])
          }
          this.hostawaitfn()
          this.$nextTick(() => {
            this.$refs.jointrader.open()
          })
        })
      })
    },
    setwebsitepost(val) {
      // 官网发文验证获取网址
      this.weburl = val
    },
    webpostfn() {
      // 官网发文提交验证
      this.$refs.Websitepost.loadfn()
      this.domainpostfn(true, (res) => {
        this.$refs.Websitepost.loadfn()
        this.close()
        // this.$refs.Websitepost.open()
        this.$nextTick(() => {
          this.$refs.stateload.open()
        })
        for (const key in res) {
          this.$set(this.dialogData, key, res[key])
        }
        this.resultpagetimer(res.pdi, (d, bool = true) => {
          console.log(d, 7376)
          if (bool) {
            this.reviewstatusfn(d)
          } else {
            this.$refs.Websitepost.open()
          }
        })
      })
    },
    traderform(item) {
      // 获取管理员审核加入表单参数
      for (const key in item) {
        this.$set(this.jointraderoaram, key, item[key])
      }
      console.log(this.jointraderoaram)
    },
    validatefn() {
      // 管理员审核加入下一步验证
      this.$refs.filltrader.loadfn()
      this.auditfn((res) => {
        this.$refs.filltrader.loadfn()
        this.close()
        this.$refs.stateload.open()
        for (const key in res) {
          this.$set(this.dialogData, key, res[key])
        }
        this.resultpagetimer(res.pdi, (d, bool = true) => {
          if (bool) {
            this.reviewstatusfn(d)
          } else {
            this.$refs.filltrader.open()
          }
        })
      })
    },
    filltradernext() {
      // 管理员审核加入-下一步
      this.$refs.filltraderref.validatefn()
      // this.validatefn()
    },
    contactusform(obj) {
      // 联系我们-其他参数
      console.log(obj, 2223)
      for (const key in obj) {
        this.$set(this.contactpost, key, obj[key])
      }
    },
    contactusnext() {
      // 人工客服联系我们提交
      console.log('contactusnext')
      this.$refs.contactusref.validatefn()
    },
    contactusvalidate() {
      console.log(this.contactpost, 3333)
      this.$refs.contactus.loadfn()
      this.claimcustomerfn(JSON.parse(JSON.stringify(this.contactpost)), (res) => {
        this.$refs.contactus.loadfn()
        // this.$message({
        //   message: res,
        //   type: 'success',
        //   onClose: () => {
        //     this.upgradeypre()
        //   }
        // })
        this.$Dialog({
          title: this.$v('提交成功'),
          confirmButtonText: this.$v('确认'),
          message: res,
          className: 'joinclass',
          overlayClass: 'overlayClass'
        }).then(() => {
          // on confirm
          this.upgradeypre()
        })
      })
    },
    claimcustomerfn(param, fn) {
      // 提交人工客服
      this.$api.common
        .CV3(param, {
          Routes: 'contact$contact'
        })
        .then((res) => {
          const result = res && res.contact && res.contact.contact
          if (result.success) {
            fn(result.data)
          } else {
            this.$refs.contactus.loadfn()
            this.$message({
              message: result.message,
              type: 'error'
            })
          }
        })
        .catch(() => {
          this.$refs.contactus.loadfn()
          this.$message({
            message: this.$v('接口超时，重新提交'),
            type: 'error'
          })
        })
    },
    auditfn(fn) {
      // 管理员审核
      // this.$refs.filltrader.loadfn()
      this.$api.common
        .CV3(
          {
            userId: this.$store.state.user.userId || '',
            enterpriseCode: this.enterpriseCode, // 企业Code
            enterpriseType: this.enterpriseType, // 服务商1，交易商2
            remark: this.jointraderoaram.remark,
            name: this.jointraderoaram.name, // 理由
            phone: this.jointraderoaram.phone, // 电话
            phoneAreaCode: this.$store.state.usergetCountry.code // 电话code
          },
          {
            Routes: 'weenterpriseaudit$joinaudit'
          }
        )
        .then((res) => {
          // this.$refs.filltrader.loadfn()
          console.log(res, 11223)
          const joinaudit = res && res.weenterpriseaudit && res.weenterpriseaudit.joinaudit.data
          if (joinaudit) {
            if (joinaudit.messageModel.succeed) fn(joinaudit)
            else {
              this.$refs.filltrader.loadfn()
              this.$message.error(joinaudit.messageModel.message)
            }
          } else {
            this.$refs.filltrader.loadfn()
            this.$message.error(this.$v('接口超时，重新提交'))
          }
        })
        .catch(() => {
          this.$refs.filltrader.loadfn()
          this.$message.error(this.$v('接口超时，重新提交'))
        })
    },
    statistics(applicationType, applicationContentType) {
      // 统计
      this.$api.common
        .CV3(
          {
            applicationType,
            applicationContentType,
            enterpriseCode: this.traderdata.code,
            enterpriseType: this.enterpriseType,
            userId: this.$store.state.user.userId || ''
          },
          {
            Routes: 'weenterpriseaudit$statistics'
          }
        )
        .then((res) => {})
    },
    listcancelf(fn) {
      // 取消验证
      this.$api.common
        .CV3(
          {
            pdi: this.pdi
          },
          {
            Routes: 'weenterpriseaudit$listcancel'
          }
        )
        .then((res) => {
          console.log(res, 11223)
          const listcancel = res?.weenterpriseaudit?.listcancel?.data
          if (listcancel) {
            if (listcancel.messageModel.succeed) {
              fn(listcancel)
            } else {
              this.$message.error(listcancel.messageModel.message)
            }
          } else {
            this.$message.error(this.$v('接口超时，重新提交'))
          }
        })
        .catch(() => {
          this.$message.error(this.$v('接口超时，重新提交'))
        })
    },
    jointraderpre() {
      // 加入、认领方式选择弹框上一步
      // this.close()
      // this.$nextTick(() => {
      //   if (this.addtradertype == 3) {
      //     return
      //   }
      //   this.$refs.Mytrader.open()
      // })
      this.close()
      this.$nextTick(() => {
        if (this.addtradertype == 3 || this.homeshow == 2 || this.homeshow == 4) {
          // 认证
          return
        }
        if (this.homeshow == 1) {
          this.$refs.tabservice.open()
          return
        }
        this.$refs.Mytrader.open()
      })
    },
    emailtabpre() {
      // 邮箱认领选择上一步
      this.close()
      this.$nextTick(() => {
        this.$refs.jointrader.open()
      })
    },
    cpemailpre() {
      // 持牌机构邮箱验证认领上一步
      this.close()
      this.$nextTick(() => {
        console.log(222)
        if (this.addtradertype == 2) {
          if (this.emaiarr.length == 0) {
            this.$refs.jointrader.open()
          } else {
            this.$refs.Emailtab.open()
          }
        } else if (this.isExistAdmin) {
          this.$refs.jointrader.open()
        } else if (this.homeshow == 1) {
          this.$refs.tabservice.open()
        } else {
          this.$refs.Mytrader.open()
        }
      })
    },
    hostvalidatepre() {
      // 官方域名验证认领上一步
      this.close()
      this.$nextTick(() => {
        this.$refs.jointrader.open()
      })
    },
    webpre() {
      // 人工客服联系我们上一步
      this.close()
      this.$nextTick(() => {
        this.$refs.jointrader.open()
      })
    },
    myemailpre() {
      // 管理员审核加入上一步
      this.close()
      this.$nextTick(() => {
        // if (this.homeshow == 1 || this.homeshow == 4) this.$refs.jointrader.open()
        // else this.$refs.Mytrader.open()
        // this.$refs.Mytrader.open()
        this.$refs.jointrader.open()
      })
    },
    skipFn() {
      // 跳过身份升级
      this.$refs.upgrade && this.$refs.upgrade.close()
      this.$refs.Identity && this.$refs.Identity.close()
      this.$refs.tabupgrade && this.$refs.tabupgrade.close()
    },
    closedialog() {
      // 弹框关闭处罚
      clearInterval(this.emailnexttimer)
      this.$emit('closedialog')
    },
    openlog(val) {
      this.modalshow = val
      this.$emit('openlog', val)
    },
    close() {
      // 关闭所有弹框
      this.$refs.upgrade && this.$refs.upgrade.close()
      this.$refs.Kolone && this.$refs.Kolone.close()
      this.$refs.Koltwo && this.$refs.Koltwo.close()
      this.$refs.Joinkol && this.$refs.Joinkol.close()
      this.$refs.Identity && this.$refs.Identity.close()
      this.$refs.Mytrader && this.$refs.Mytrader.close()
      this.$refs.stateawait && this.$refs.stateawait.close()
      this.$refs.verifyemail && this.$refs.verifyemail.close()
      this.$refs.jointrader && this.$refs.jointrader.close()
      this.$refs.joinemail && this.$refs.joinemail.close()
      this.$refs.jobselection && this.$refs.jobselection.close()
      this.$refs.filltrader && this.$refs.filltrader.close()
      this.$refs.domaindetection && this.$refs.domaindetection.close()
      this.$refs.htmlverify && this.$refs.htmlverify.close()
      this.$refs.webverify && this.$refs.webverify.close()
      this.$refs.Fillsubjectone && this.$refs.Fillsubjectone.close()
      this.$refs.tabservice && this.$refs.tabservice.close()
      this.$refs.Fillsubjecttwo && this.$refs.Fillsubjecttwo.close()
      this.$refs.contactus && this.$refs.contactus.close()
      this.$refs.servicetype && this.$refs.servicetype.close()
      this.$refs.subservicetype && this.$refs.subservicetype.close()
      this.$refs.claimsubject && this.$refs.claimsubject.close()
      this.$refs.tradertype && this.$refs.tradertype.close()
      this.$refs.createservice && this.$refs.createservice.close()
      this.$refs.tabserviceadd && this.$refs.tabserviceadd.close()
      this.$refs.hostvalidate && this.$refs.hostvalidate.close()
      this.$refs.Hostexamine && this.$refs.Hostexamine.close()
      this.$refs.Emailtab && this.$refs.Emailtab.close()
      this.$refs.Websitepost && this.$refs.Websitepost.close()
      this.$refs.Licensed && this.$refs.Licensed.close()
      this.$refs.Newtoexamine && this.$refs.Newtoexamine.close()
      this.$refs.Emailverify && this.$refs.Emailverify.close()
      this.$refs.Emailverification && this.$refs.Emailverification.close()
      this.$refs.tabupgrade && this.$refs.tabupgrade.close()
    },
    tokefufn() {
      // 跳转到人工客服
      console.log(456)
      // this.close()
      // this.$nextTick(() => {
      //   this.$refs.contactus.open()
      //   this.$nextTick(() => {
      //     this.$refs.contactusref.setcompanyName(this.traderdata.showName)
      //   })
      // })
      // this.$store.commit('contract/set_claimEnterprise', {
      //   name: this.traderdata.showName,
      //   code: this.traderdata.code || this.dialogData.enterpriseCode
      // })
      this.$nextTick(() => {
        const name = encodeURI(this.traderdata.showName)
        window.open(
          `https://www.${this.$store.state.newhost}.${this.getSuffix(this.$store.state)}/${this.$store.state.LanguageCode}/contract.html?code=${this.traderdata.code || this.dialogData.enterpriseCode}&name=${name}&type=6`
        )
      })
    },
    closeNewtoexamine() {
      this.$refs.Newtoexamine && this.$refs.Newtoexamine.close()
    },
    getweburlfn(fn) {
      // 获取官方网址
      this.$api.common
        .CV3(
          {
            enterpriseCode: this.enterpriseCode,
            reutrnType: 2
          },
          {
            Routes: 'weenterpriseaudit$personalapplicationwebsite'
          }
        )
        .then((res) => {
          console.log(res, 556)
          const d = res?.weenterpriseaudit?.personalapplicationwebsite?.data || []
          fn(d)
        })
    },
    async getuserisenterprise() {
      // 获取用户信息
      if (this.$store.state.contentcookie) {
        const getuser = await this.$api.common
          .CV3(
            // 用户信息
            {
              ApplicationType: 7,
              CountryCode: this.$store.state.CountryCode,
              LanguageCode: this.$store.state.LanguageCode,
              userId: this.$store.state.user.userId ? this.$store.state.user.userId : ''
            },
            {
              Routes: 'usercenter$getuserv5'
            }
          )
          .catch(() => {
            console.log('getuserv5')
          })

        console.log('getuser: ', getuser)
        if (getuser && getuser.usercenter && getuser.usercenter.getuserv5 && getuser.usercenter.getuserv5.data) {
          this.wikinum = getuser.usercenter.getuserv5.data.wikinum
        }
      }
    },
    urlfn(val) {
      this.weburl = val
    },
    domaincheckfn(fn) {
      // 域名验证
      this.$api.common
        .CV3(
          {
            userId: this.$store.state.user.userId || '',
            enterpriseCode: this.traderdata.code || this.dialogData.enterpriseCode,
            enterpriseType: this.enterpriseType,
            pdi: this.dialogData.pdi,
            applicationType: this.addtradertype == 2 ? 2 : 4,
            checkType: 'txt',
            url: this.weburl,
            skyEyeNumber: this.wikinum,
            version: 2
          },
          {
            Routes: 'weenterpriseaudit$domaincheck'
          }
        )
        .then((res) => {
          console.log(res, 556)
          const d = res?.weenterpriseaudit?.domaincheck?.data || []
          if (!d) {
            this.$refs.hostvalidate.loadfn()
            this.$message.error(this.$v('接口超时，重新提交'))
          } else if (d.messageModel.succeed) {
            fn(d, true)
          } else {
            this.$refs?.hostvalidate.loadfn()
            this.$message.error(d.messageModel.message)
          }
        })
        .catch(() => {
          this.$refs?.hostvalidate.loadfn()
          this.$message.error(this.$v('接口超时，重新提交'))
        })
    },
    resultpage(pdi, fn) {
      // 审核结果页，需要轮询请求--指定域名检测认证提交之后进行查询状态
      this.$api.common
        .CV3(
          {
            pdi
          },
          {
            Routes: 'weenterpriseaudit$resultpage'
          }
        )
        .then((res) => {
          console.log(res, 8888)
          const result = res && res.weenterpriseaudit && res.weenterpriseaudit.resultpage
          fn(result)
        })
    },
    resultpagetimer(pdi, fn) {
      // 审核结果轮询
      let count = 1
      // this.$refs.stateload.open()
      const timer = setInterval(() => {
        count++
        this.resultpage(pdi, (result) => {
          console.log(result, 776)
          // this.$refs.stateload.close()
          if (result.success) {
            // 接口请求成功
            if (!result.data.loop) {
              // 不需要轮询
              count = 1
              clearInterval(timer)
              this.$refs.stateload.close()
              fn(result.data)
            } else if (result.data.loop && count >= 5) {
              // 需要轮询，次数大于8次跳转到失败页面
              clearInterval(timer)
              count = 1
              fn(result.data, true)
              // this.$refs.createservice.loadfn()
              this.$refs.stateload.close()
              // this.$message.error(this.$v('接口超时，重新提交'))
            }
          } else {
            // 接口请求失败
            clearInterval(timer)
            count = 1
            fn(result.data, false)
            // this.$refs.createservice.loadfn()
            this.$refs.stateload.close()
            this.$message.error(this.$v('接口超时，重新提交'))
          }
        })
      }, 2500)
    },
    awaitfn() {
      // 稍后提交
      this.$refs?.stateawait.close()
      this.$refs?.Newtoexamine.close()
      this.$refs?.Hostexamine.close()
    },
    tocompany() {
      // 跳转到企业页面
      if (this.$store.state.mobile) window.open(`https://eco.tech003.com/${this.$store.state.LanguageCode}`)
      else window.open(`https://www.wikifxmanager.com/${this.$store.state.LanguageCode}/login?contentcookie=${encodeURI(this.$store.state.contentcookie)}`)
    },
    personalapplicationdetailfn(fn) {
      // 获取稍后提交参数
      this.$api.common
        .CV3(
          {
            pdi: this.dialogData.pdi,
            applicationContentType: this.dialogData.applicationContentType // 1.创建申请 2.指定域名检测认证 3.官网发文验证 4.联系我们 5.管理员加入 6.企业加入 7.提交证明资料 8.Kol申请
          },
          {
            Routes: 'weenterpriseaudit$personalapplicationdetail'
          }
        )
        .then((res) => {
          const data = (res && res.weenterpriseaudit && res.weenterpriseaudit.personalapplicationdetail) || {}
          if (data.success) {
            fn(data.data)
          } else {
            this.$message.error(data.message)
          }
        })
        .catch(() => {})
    },
    simplemain(code, fn) {
      // 获取服务商简易主信息
      this.$api.common
        .CV3(
          {
            enterpriseCode: code
          },
          {
            Routes: 'weenterpriseaudit$enterpriseinfoagg'
          }
        )
        .then((res) => {
          const simplemain = res?.weenterpriseaudit?.enterpriseinfoagg?.data?.aggData?.subject
          console.log(simplemain, 775)
          if (simplemain) fn(simplemain)
          else {
            const trader = localStorage.getItem('trader') || '{}'
            fn(JSON.parse(trader))
          }
        })
        .catch((err) => {
          console.log(err, 333)
          this.$message.error(this.$v('接口超时，重新提交'))
        })
    },
    hostawaitfn() {
      // 官网域名验证重新提交
      this.$refs.Hostexamine.close()
      this.$refs.Newtoexamine.close()
      this.$refs.stateawait.close()
    },
    websiteoremailfn(screeningType, returnType, fn) {
      // 获取企业网址或者邮箱
      this.$api.common
        .CV3(
          {
            code: this.enterpriseCode,
            type: this.enterpriseType,
            screeningType, // 1-只有持牌机构；2-通用；3包含持牌机构
            returnType // 1-网址； 2--email
          },
          {
            Routes: 'weenterprisemanage$websiteoremail'
          }
        )
        .then((res) => {
          console.log(res.weenterprisemanage.websiteoremail.data, 777)
          const r = res?.weenterprisemanage?.websiteoremail?.data || []
          fn(r)
        })
        .catch(() => {
          this.$message.error(this.$v('接口超时，重新提交'))
          this.$refs && this.$refs.Emailtab.loadfn()
        })
    },
    emailprefixfn(fn) {
      // 获取邮箱前缀
      this.$api.common
        .CV3(
          {
            enterpriseCode: this.enterpriseCode,
            userId: this.$store.state.user.userId || ''
          },
          {
            Routes: 'weenterpriseaudit$emailprefix'
          }
        )
        .then((res) => {
          const r = res?.weenterpriseaudit?.emailprefix?.data || []
          fn(r)
        })
        .catch(() => {
          this.$message.error(this.$v('接口超时，重新提交'))
        })
    },
    sendcodefn(email, emailAuditType, fn) {
      // 发送验证码
      this.$api.common
        .CV3(
          {
            userId: this.$store.state.user.userId || '',
            enterpriseCode: this.enterpriseCode,
            enterpriseType: this.enterpriseType,
            email,
            applicationType: this.apptype,
            emailAuditType
          },
          {
            Routes: 'weenterpriseaudit$emailsendcodev2'
          }
        )
        .then((res) => {
          console.log(res.weenterpriseaudit.emailsendcodev2, 777)
          const r = res?.weenterpriseaudit?.emailsendcodev2 || {}
          if (r.data) {
            if (r.data.succeed) {
              fn(r.data)
            } else {
              this.$message.error(r.data.message)
            }
          } else {
            this.$message.error(r.message || this.$v('接口超时，重新提交'))
          }
        })
        .catch(() => {
          this.$message.error(this.$v('接口超时，重新提交'))
        })
    },
    emailverifyfn(fn) {
      // 邮箱验证
      this.$api.common
        .CV3(
          {
            userId: this.$store.state.user.userId || '',
            enterpriseCode: this.enterpriseCode,
            enterpriseType: this.enterpriseType,
            email: this.email,
            emailCode: this.emailCode,
            applicationType: this.apptype, // 持牌机构认领认证的时候传一下      默认是6，用户申请加入，持牌机构加入调这个接口的时候根据场景传2或者4
            emailAuditType: this.emailAuditType //  老版本流程 Default = 0小于等于5分，或服务商 Let5 = 1交易商5分以上，或服务商 Gt5 = 2持牌机构 Linese = 3
          },
          {
            Routes: 'weenterpriseaudit$emailjoin'
          }
        )
        .then((res) => {
          console.log(res.weenterpriseaudit.emailjoin.data, 777)
          this.$refs.Emailverify && this.$refs.Emailverify.loadfn()
          const r = res?.weenterpriseaudit?.emailjoin.data
          if (!r) {
            // this.$message.error(res.weenterpriseaudit.emailjoin.message)
            if (this.$store.state.mobile) {
              this.$message({
                message: res.weenterpriseaudit.emailjoin.message,
                type: 'warning'
              })
            } else {
              this.$message.error(res.weenterpriseaudit.emailjoin.message)
            }
            return
          }
          if (!r.messageModel.succeed) {
            if (this.$store.state.mobile) {
              this.$message({
                message: r.messageModel.message,
                type: 'warning'
              })
            } else {
              this.$message.error(r.messageModel.message)
            }
            return
          }
          this.close()
          this.$nextTick(() => {
            this.$refs.stateload.open()
            setTimeout(() => {
              this.$refs.stateload.close()
              this.$nextTick(() => {
                if (r.messageModel.succeed) {
                  fn(r, true)
                } else {
                  this.verifyshow = true
                  this.$refs.Emailverify.open()
                  this.$nextTick(() => {
                    this.$refs.Emailverifyref.inittw()
                  })
                  this.$Toast.fail({
                    message: r.messageModel.message,
                    icon: 'none',
                    duration: 2000,
                    getContainer: '#verifyemail'
                  })
                  // this.$message.error(r.messageModel.message)
                }
              })
            }, 2000)
          })
        })
        .catch(() => {
          this.$message.error(this.$v('接口超时，重新提交'))
          this.$refs.Emailverify && this.$refs.Emailverify.loadfn()
        })
    },
    goodregulatoryscorefn(fn) {
      // 是否是好的监管评分
      this.$api.common
        .CV3(
          {
            traderCode: this.enterpriseCode
          },
          {
            Routes: 'wikifxagg$goodregulatoryscore'
          }
        )
        .then((res) => {
          console.log(res.wikifxagg.goodregulatoryscore, 777)
          const r = res?.wikifxagg?.goodregulatoryscore?.data
          fn(r)
          // if (r) {
          //   fn(r.data)
          // } else {
          //   this.$message.error(r.message)
          // }
        })
        .catch(() => {
          this.$message.error(this.$v('接口超时，重新提交'))
          this.$refs && this.$refs.Emailtab.loadfn()
        })
    },
    domainpostfn(isCommit = true, fn) {
      // 官网发文验证接口-----接口报错
      this.$api.common
        .CV3(
          {
            userId: this.$store.state.user.userId || '',
            enterpriseType: this.enterpriseType,
            applicationType: this.addtradertype == 2 ? 2 : 4,
            postUrl: this.weburl,
            url: this.traderdata?.website?.[0],
            enterpriseCode: this.enterpriseCode,
            isCommit
          },
          {
            Routes: 'weenterpriseaudit$domainpost'
          }
        )
        .then((res) => {
          console.log(res.weenterpriseaudit.domainpost, 777)
          const r = res?.weenterpriseaudit?.domainpost?.data
          // fn(r)
          if (!r) {
            // fn(r.data)
            this.$refs.Websitepost.loadfn()
            this.$message.error(res.weenterpriseaudit.domainpost.message)
          } else {
            fn(r)
          }
        })
        .catch(() => {
          this.$message.error(this.$v('接口超时，重新提交'))
          this.$refs.Websitepost.loadfn()
        })
    },
    createserve() {
      // 创建服务商
      this.close()
      this.servicetypelist((res) => {
        this.servicetypedata = [...res]
        this.servicetypedataall = [...res]
        this.servicetypedata.forEach((item) => {
          item.dis = false
        })
        this.servicetypeparam = {}
        this.$nextTick(() => {
          this.$refs.servicetype.open()
          this.$nextTick(() => {
            this.$refs.servicetypeselect.init()
            this.$refs.servicetypeselect.initdata()
          })
        })
      })
    },
    servicetypelist(fn) {
      // 获取企业服务类型
      this.$api.common
        .CV3(
          {},
          {
            Routes: 'weenterprisemanage$servicetypelist'
          }
        )
        .then((res) => {
          console.log(res, 33)
          const servicetypelist = res && res.weenterprisemanage && res.weenterprisemanage.servicetypelist && res.weenterprisemanage.servicetypelist.data
          fn(servicetypelist)
        })
        .catch(() => {
          this.$refs.tabservice.loadfn()
          this.$message.error(this.$v('接口超时，重新提交'))
        })
    },
    createservicepre() {
      // 创建服务商表单上一步
      this.close()
      if (this.subservicetypedata.length > 0) {
        // this.subservicetypedata = []
        this.$nextTick(() => {
          this.$refs.subservicetype.open()
          this.$nextTick(() => {
            this.$refs.subservicetypeselect.init()
          })
        })
      } else {
        this.servicetypedata = JSON.parse(JSON.stringify(this.servicetypedataall))
        // this.servicetypeparam = {}
        this.$nextTick(() => {
          this.$refs.servicetype.open()
          this.$nextTick(() => {
            this.$refs.servicetypeselect.init()
          })
        })
      }
    },
    createservicenext() {
      // 创建服务商 - 提交审核
      const param = JSON.parse(JSON.stringify(this.createparam))
      param.companyFoundDate = dayjs(this.createparam.companyFoundDate).format('YYYY-MM-DD')
      console.log(param, 2224)
      this.$refs.createservice.loadfn()
      this.createserviceprovider(param, (res) => {
        console.log(res, 232)
        const trader = {
          showName: param.companyShortName
        }
        localStorage.setItem('trader', JSON.stringify(trader))
        this.$refs.createservice.loadfn()
        this.close()
        this.$nextTick(() => {
          this.$refs.stateload.open()
          this.resultpagetimer(res.pdi, (d, bool = true) => {
            console.log(d, 776)
            if (bool) {
              this.reviewstatusfn(d)
            } else {
              this.$refs.createservice.open()
            }
          })
        })
      })
    },
    subservicetypenext() {
      // 选择次要服务下一步
      this.close()
      this.$refs.createservice.open()
      this.$nextTick(() => {
        this.$refs.createserviceref.renew()
      })
    },
    createform(param) {
      // 创建服务商-获取参数
      console.log(param)
      for (const key in param) {
        this.$set(this.createparam, key, param[key])
      }
    },
    servicedatafn(val) {
      // 选择主要服务类型-获取选择的服务类型
      for (const key in val) {
        this.$set(this.servicetypeparam, key, val[key])
      }
      console.log(val, 111)
    },
    subservicedatafn(arr) {
      // 选择次要服务类型-获取选择的服务类型
      console.log(arr, 111)
      this.subservicetypedata = [...arr]
    },
    servicetypenext() {
      // 选择主要服务下一步
      this.close()
      // this.subservicetypedata = []
      if (this.servicetypeparam.serviceCode == '39459757') {
        this.subservicetypedata = []
        this.$refs.createservice.open()
        this.$nextTick(() => {
          this.$refs.createserviceref.renew()
        })
        return
      }
      const arr = JSON.parse(JSON.stringify(this.servicetypedata))
      this.servicetypedata = arr.filter((item) => this.servicetypeparam.serviceCode != item.serviceCode)
      this.subservicetypedata = []
      this.$nextTick(() => {
        this.$refs.subservicetype.open()
        this.$nextTick(() => {
          this.$refs.subservicetypeselect.init()
          this.$refs.subservicetypeselect.initdata()
        })
      })
    },
    servicetypepre() {
      // 选择主要服务上一步
      this.close()
      this.$nextTick(() => {
        this.$refs.Mytrader.open()
      })
    },
    subservicetypepre() {
      // 选择次要服务上一步
      this.servicetypedata = JSON.parse(JSON.stringify(this.servicetypedataall))
      this.close()
      this.$nextTick(() => {
        this.$refs.servicetype.open()
        this.$nextTick(() => {
          this.$refs.servicetypeselect.init()
        })
      })
    },
    createserviceprovider(param, fn) {
      // 创建服务商申请-userId: this.$store.state.user.userId || '',
      this.$api.common
        .CV3(
          {
            userId: this.$store.state.user.userId || '',
            ...param
          },
          {
            Routes: 'weenterpriseaudit$createserviceprovider'
          }
        )
        .then((res) => {
          console.log(res, 323)
          const createserviceprovider = res && res.weenterpriseaudit && res.weenterpriseaudit.createserviceprovider
          if (createserviceprovider.data) {
            if (createserviceprovider.data.messageModel.succeed) {
              fn(createserviceprovider.data)
            } else {
              this.$refs.createservice.loadfn()
              this.$message.error(createserviceprovider.data.messageModel.message)
            }
          } else {
            this.$refs.createservice.loadfn()
            this.$message.error(createserviceprovider.message)
          }
        })
        .catch((err) => {
          console.log(err, 333)
          this.$refs.createservice.loadfn()
          this.$message.error(this.$v('接口超时，重新提交'))
        })
    },
    reviewstatusfn(item) {
      // 审核状态
      // if (item.resultPageType == 4 && item.applicationContentType == 5) { // 方式二：管理员审核加入审核失败
      //   this.Toexaminestate = 'error'
      //   this.homeshow = 4
      //   this.errorp1 = this.$v('提交失败，请重试')
      //   this.errorp2 = item.remark
      //   // this.awaitext = this.$v('进入首页')
      //   this.$nextTick(() => {
      //     this.$refs.Newtoexamine.open()
      //   })
      // }
      if (item.resultPageType == 2 && item.applicationContentType == 2) {
        // 官方域名验证认领认证-审核中
        this.Toexaminestate = 'await'
        this.homeshow = 4
        setTimeout(() => {
          this.$refs.Hostexamine.open()
        }, 200)
        this.$emit('awaitfn')
      } else if (item.resultPageType == 3 && item.applicationContentType == 2) {
        // 官方域名验证认领认证-审核成功
        this.Toexaminestate = 'success'
        this.successp = this.addtradertype == 2 ? this.$v('恭喜您，认领成功') : this.addtradertype == 3 ? this.$v('恭喜您，认证成功') : this.$v('恭喜您，加入成功')
        this.successtext = this.addtradertype == 1 ? this.$v('查看企业') : this.$v('管理企业')
        setTimeout(() => {
          this.$refs.stateawait.open()
        }, 200)
        this.$emit('succeedfn')
      } else if ((item.resultPageType == 4 || item.resultPageType == 7) && item.applicationContentType == 2) {
        // 官方域名验证认领认证-审核失败
        this.Toexaminestate = 'error'
        this.homeshow = 4
        setTimeout(() => {
          this.$refs.Hostexamine.open()
        }, 200)
      } else if (item.resultPageType == 3 && item.applicationContentType == 6) {
        // 企业邮箱加入 企业邮箱加入-审核成功
        this.Toexaminestate = 'success'
        this.successp = this.addtradertype == 2 ? this.$v('恭喜您，认领成功') : this.addtradertype == 3 ? this.$v('恭喜您，认证成功') : this.$v('恭喜您，加入成功')
        this.successtext = this.addtradertype == 1 ? this.$v('查看企业') : this.$v('管理企业')
        setTimeout(() => {
          this.$refs.stateawait.open()
        }, 200)
        this.$emit('succeedfn')
      } else if (item.resultPageType == 2 && item.applicationContentType == 3) {
        // 官方发文-审核中
        this.Toexaminestate = 'await'
        this.homeshow = 4
        this.awaitp1 = this.addtradertype == 2 ? this.$v('资料已提交，认领审核中') : this.addtradertype == 3 ? this.$v('资料已提交，认证审核中') : this.$v('资料已提交，加入审核中')
        this.awaitp2 = this.$v('为保证认证通过，一定不要删除您发布的内容')
        this.awaitext = this.$v('进入首页')
        this.$nextTick(() => {
          this.$refs.stateawait.open()
        })
        this.$emit('awaitfn')
      } else if (item.resultPageType == 3 && item.applicationContentType == 3) {
        // 官方发文-审核成功
        this.Toexaminestate = 'success'
        this.successp = this.addtradertype == 2 ? this.$v('恭喜您，认领成功') : this.addtradertype == 3 ? this.$v('恭喜您，认证成功') : this.$v('恭喜您，加入成功')
        this.successtext = this.addtradertype == 1 ? this.$v('查看企业') : this.$v('管理企业')
        setTimeout(() => {
          this.$refs.stateawait.open()
        }, 200)
        this.$emit('succeedfn')
      } else if ((item.resultPageType == 7 || item.resultPageType == 4) && item.applicationContentType == 3) {
        // 官方发文-审核失败
        this.Toexaminestate = 'error'
        this.homeshow = 4
        setTimeout(() => {
          this.$refs.Hostexamine.open()
          this.$nextTick(() => {
            this.$refs.Hostexamineref.setshow('2')
          })
        }, 200)
      } else if (item.resultPageType == 2 && item.applicationContentType == 14) {
        // 方式四：人工客服认领-审核中
        this.Toexaminestate = 'await'
        this.homeshow = 4
        setTimeout(() => {
          this.$refs.stateawait.open()
          this.$nextTick(() => {
            this.$refs.stateawaitref.setawaitshow('2')
          })
        }, 200)
        this.$emit('awaitfn')
      } else if ((item.resultPageType == 4 || item.resultPageType == 7) && item.applicationContentType == 14) {
        // 方式四：人工客服认领-审核失败
        this.Toexaminestate = 'error'
        this.errorp1 = this.$v('审核资料不通过')
        // this.errorp2 = item.remark
        this.errorp2 = this.$v('管理员拒绝了您的申请')
        this.homeshow = 4
        setTimeout(() => {
          this.$refs.stateawait.open()
          // this.$nextTick(() => {
          //   this.$refs.Hostexamineref.setshow('2')
          // })
        }, 200)
      } else if (item.resultPageType == 2 && item.applicationContentType == 5) {
        // 方式二：管理员审核加入审核中
        this.Toexaminestate = 'await'
        this.homeshow = 4
        this.awaitp1 = this.$v('资料已提交，加入审核中')
        this.awaitp2 = this.$v('待企业管理员同意后，即可加入企业')
        this.awaitext = this.$v('进入首页')
        this.$nextTick(() => {
          this.$refs.Newtoexamine.open()
        })
        this.$emit('awaitfn')
      } else if (item.resultPageType == 4 && item.applicationContentType == 5) {
        // 方式二：管理员审核加入审核失败
        this.Toexaminestate = 'error'
        this.errorp1 = this.$v('审核不通过')
        this.homeshow = 4
        // this.errorp2 = item.remark
        this.errorp2 = this.$v('管理员拒绝了您的申请')
        // this.awaitext = this.$v('进入首页')
        this.$nextTick(() => {
          this.$refs.Newtoexamine.open()
        })
      } else if (item.resultPageType == 3 && item.applicationContentType == 5) {
        // 方式二：管理员审核加入-审核成功
        this.Toexaminestate = 'success'
        this.successp = this.addtradertype == 2 ? this.$v('恭喜您，认领成功') : this.addtradertype == 1 ? this.$v('恭喜您，加入成功') : this.$v('恭喜您，认证成功')
        this.successtext = this.$v('查看企业')
        setTimeout(() => {
          this.$refs.stateawait.open()
        }, 200)
        this.$emit('succeedfn')
      } else if (item.resultPageType == 3 && item.applicationContentType == 1) {
        // 创建服务商成功
        this.Toexaminestate = 'success'
        this.successp = this.$v('恭喜您，创建成功')
        this.successtext = this.$v('管理企业')
        this.$nextTick(() => {
          this.$refs.stateawait.open()
        })
        this.$emit('succeedfn')
      } else if (item.resultPageType == 2 && item.applicationContentType == 1) {
        // 创建服务商成功
        this.Toexaminestate = 'success'
        this.successp = this.$v('恭喜您，创建成功')
        this.successtext = this.$v('管理企业')
        this.$nextTick(() => {
          this.$refs.stateawait.open()
        })
        this.$emit('awaitfn')
      }
    },
    lookcompany() {
      // 重新提交
      this.personalapplicationdetailfn(async (res) => {
        // 获取稍后提交参数
        console.log(res, 3133)
        this.enterpriseType = res.enterpriseType
        this.enterpriseCode = res.enterpriseCode
        if (res.applicationType == 2) {
          // 认领
          this.addtradertype = 2
        } else if (res.applicationType == 4) {
          // 认证
          this.addtradertype = 3
        } else if (res.applicationType == 6) {
          // 加入
          this.addtradertype = 1
        }
        this.dialogData = {}
        for (const key in res) {
          this.$set(this.dialogData, key, res[key])
        }
        this.$set(this.dialogData, 'resultPageType', res.approvalStatus)
        if (this.dialogData.applicationContentType == 2) {
          // 域名验证
          this.totraderverify({ index: 0 })
        } else if (this.dialogData.applicationContentType == 5) {
          // 管理员审核加入
          this.jointraderoaram = {}
          this.close()
          this.$nextTick(() => {
            if (this.dialogData.resultPageType == 4) {
              this.$refs.filltrader.open()
            } else {
              window.open(`https://www.${this.$store.state.newhost}.${this.getSuffix(this.$store.state)}/${this.$store.state.LanguageCode}/`)
            }
            // this.$refs.filltrader.open()
          })
        } else if (this.dialogData.applicationContentType == 14) {
          // 方式四：人工客服认领
          this.jointraderoaram = {}
          this.close()
          this.$nextTick(() => {
            this.totraderverify({ index: 3 })
          })
        } else if (this.dialogData.applicationContentType == 3) {
          // 方式三：官网发文认领
          await this.getuserisenterprise()
          this.close()
          this.$nextTick(() => {
            this.$refs.Websitepost.open()
          })
        }
      })
    },
    tohelp() {
      window.open(`https://www.${this.$store.state.newhost}.${this.getSuffix(this.$store.state)}/${this.$store.state.LanguageCode}/help.html?type=${this.addtradertype}`)
    },
    searchshowfn(bool) {
      this.searchshow = bool
    }
  }
}
